import React from 'react';
import type { SanitySupportArticleSectionHeading } from '@repo/models/gatsby-graphql-types';

interface SupportArticleHeadingProps {
  section?: SanitySupportArticleSectionHeading;
}

function SupportArticleHeading({
  section,
}: Readonly<SupportArticleHeadingProps>) {
  return section.type === 'h2' ? (
    <h2 id={section._key}>{section.text}</h2>
  ) : (
    <h3 id={section._key}>{section.text}</h3>
  );
}

export default SupportArticleHeading;
